/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_VoiceInputs */

const en_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

const ar_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#صوتي`)
};

const bn_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

const de_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

const es_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

const fr_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

const pt_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

const zh_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

const tr_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

const ru_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

const pl_svtag_voice = /** @type {(inputs: Svtag_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VOICE`)
};

/**
* | output |
* | --- |
* | "#VOICE" |
*
* @param {Svtag_VoiceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_voice = /** @type {((inputs?: Svtag_VoiceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_VoiceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_voice(inputs)
	if (locale === "bn") return bn_svtag_voice(inputs)
	if (locale === "de") return de_svtag_voice(inputs)
	if (locale === "es") return es_svtag_voice(inputs)
	if (locale === "fr") return fr_svtag_voice(inputs)
	if (locale === "pt") return pt_svtag_voice(inputs)
	if (locale === "zh") return zh_svtag_voice(inputs)
	if (locale === "tr") return tr_svtag_voice(inputs)
	if (locale === "ru") return ru_svtag_voice(inputs)
	if (locale === "pl") return pl_svtag_voice(inputs)
	return en_svtag_voice(inputs)
});